'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var encodeJid = function encodeJid(_ref) {
  var host = _ref.host,
    user = _ref.user,
    resource = _ref.resource;
  var parsedResource = resource ? '/' + resource : '';
  return user + '@' + host + parsedResource;
};
var decodeJid = function decodeJid() {
  var jid = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var _indexOfBar = jid.indexOf('/');
  var _endDomain = _indexOfBar > 0 ? _indexOfBar : jid.length;
  var host = jid.substring(jid.indexOf('@') + 1, _endDomain);
  var user = jid.substring(0, jid.indexOf('@'));
  var resource = _indexOfBar > 0 ? jid.substring(_indexOfBar + 1, jid.length) : '';
  return {
    host: host,
    user: user,
    resource: resource
  };
};
exports.decodeJid = decodeJid;
exports.encodeJid = encodeJid;